import { ca } from '@cian/analytics';
import { getNewbuildingProduct } from '../../utils/analytics';

export function trackOpenContactsClick(gaLabel: string, promoId: string, newbuildingId: number) {
  ca('eventSite', {
    action: 'Open_jk_mortgage',
    category: 'Phones',
    label: gaLabel,
    name: 'oldevent',
    products: [
      getNewbuildingProduct({
        newbuildingId,
        extra: {
          promotion_id: promoId,
        },
      }),
    ],
  });
}
